import { overviewPoints, quickFacts, timelineSteps } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Overview() {
  return (
    <section id="overview" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="剧情梗概"
            title="一段平静婚姻里的裂缝，如何慢慢显现"
            desc="故事的核心并不复杂，却足够耐人寻味：当最亲近的家人之间出现无法言说的距离，善意与边界之间的拉扯，会把人推向哪里。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 md:mt-10 rounded-lg bg-primary-50 border border-primary-200 p-5 md:p-8">
            <div className="flex items-start gap-3 md:gap-4">
              <span className="service-icon-wrap shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-lightbulb-flash-line text-xl"></i>
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  一句话看懂
                </h3>
                <p className="mt-2 text-sm md:text-base text-foreground-700 leading-relaxed">
                  一段看似平静的婚姻，因突如其来的疏远而失衡；当身为心理医生的姐姐出于善意介入，被掩藏的情感与禁忌，也随着每一次对话逐渐浮出水面。故事最终没有给出简单的对错，而是把判断交回给观众。
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {quickFacts.map((fact, i) => (
            <Reveal key={fact.label} delay={i * 60}>
              <div className="h-full rounded-lg bg-background-100 border border-background-200 p-4 md:p-5">
                <p className="text-xs text-foreground-500 font-label tracking-wide">{fact.label}</p>
                <p className="mt-2 text-sm md:text-base font-medium text-foreground-900 leading-snug">
                  {fact.value}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
          <div>
            <Reveal>
              <h3 className="font-heading text-lg md:text-2xl font-semibold text-foreground-950">
                故事从哪几个层面展开
              </h3>
            </Reveal>
            <div className="mt-5 grid sm:grid-cols-2 gap-3 md:gap-4">
              {overviewPoints.map((point, i) => (
                <Reveal key={point.title} delay={i * 60}>
                  <div className="h-full rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
                    <span className="service-icon-wrap rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                      <i className={`${point.icon} text-lg`}></i>
                    </span>
                    <h4 className="mt-3 font-heading text-sm md:text-base font-semibold text-foreground-900">
                      {point.title}
                    </h4>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {point.text}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div>
            <Reveal>
              <h3 className="font-heading text-lg md:text-2xl font-semibold text-foreground-950">
                主线脉络一览
              </h3>
            </Reveal>
            <div className="mt-5 relative">
              <span className="absolute left-[15px] top-2 bottom-2 w-px bg-background-300"></span>
              <ul className="space-y-5">
                {timelineSteps.map((step, i) => (
                  <Reveal key={step.index} delay={i * 60}>
                    <li className="relative pl-11">
                      <span className="absolute left-0 top-0 w-8 h-8 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-xs font-semibold">
                        {step.index}
                      </span>
                      <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                        {step.title}
                      </h4>
                      <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                        {step.text}
                      </p>
                    </li>
                  </Reveal>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}